// kyc update

import React, { useState,useEffect, useRef } from "react";
import { View, Image,Text, ScrollView, TouchableOpacity,} from "react-native";
import { UploadKYCDoc, sendOtpApi, updateKyc, getEncryptKey,getUserDetails} from "../../api/apiManager";
import ModalAlert from "../../common/ModalAlert";
import AsyncStorageFunc from "../../utilities/asyncStorage";
import {jwtDecode} from "jwt-decode";
import crownicon from "../../assets/images/crownicon.png";
import Loader from "../../common/Loader";
import CText from "../../common/CText";
import { COLORS } from "../../constant";
import OtpModal from "../../common/OtpModal";
import CServiceReqBoxView from "../../common/CServiceReqBoxView";
import { Encryption as encrypt } from "../../utilities/Encryption";
import RootNavigation from "../../utilities/RootNavigation";
import useStyles from "./KycUpdate_Styles.";
import CDocxViewer from "../../common/CDocxViewer";

export default function ServiceRequest(props) {
  const styles = useStyles();
  const [kycStatus,setKycStatus] = useState("")
  const [loading, setLoading] = useState(false);
  const [isPanValidated, setIsPanValidated] = useState(false)
  const [panImage, setPanImage] = useState();
  const [frontImage, setFrontImage] = useState();
  const [backImage, setBackImage] = useState();
  const [photoImage, setPhotoImage] = useState();
  const [panNumber, setPanNumber] = useState("");
  const [value, setValue] = useState("DL");
  const [tncModalVisible, setTncModalVisible] = useState(false);
  const [otpData, setOtpData] = useState(false)
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [otpModalVisible, setOtpModalVisible] = useState(false);
  const [addressDetails, setAddressDetails] = useState({
    house: "",
    street: "",
    area: "",
    district: "",
    postalCode: "",
    village: "",
    state: "",
    country:'India'
  });
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  useEffect(()=>{getProfileDetails()},[])

  const getProfileDetails = () => {
    setLoading(true);
        getUserDetails()
          .then((res) => {
            setLoading(false);
            setKycStatus(res?.kyc)
          })
          .catch(() => {
            setLoading(false);
          });
  };

  const onCloseModal = () => {
    setAlertModalVisible(false);
    if (alertModal.status == "request_initiated") {
      RootNavigation.navigate("serviceRequest")
    }
  };

  const resetData = () => {
    setPanImage("");
    setFrontImage("");
    setBackImage("");
    setPhotoImage("");
    setPanImageText("");
    setFrontImageText("");
    setBackImageText("");
    setPhotoImageText("");
    setAddressDetails({
      house: "",
      street: "",
      area: "",
      district: "",
      postalCode: "",
      village: "",
      state: "",
      country:'India'
    })
  };

  const onUpload = () => {
    setLoading(true);
    setOtpModalVisible(false)
    let uploadPayload = new FormData();
    uploadPayload.append("filetype", value);
    uploadPayload.append("frontfile", panImage);
    uploadPayload.append("frontfile", photoImage);
    uploadPayload.append("address", JSON.stringify(addressDetails) );
    uploadPayload.append("docNo", "");
    if (value == "Aadhaar Card") {
      let finalfront = frontImage
      let finalBack = backImage
      uploadPayload.append("frontfile", finalfront, "AadhaarFront.png");
      uploadPayload.append("frontfile", finalBack, 'AadhaarBack.png');
    } else {
      uploadPayload.append("frontfile", backImage);
      uploadPayload.append("frontfile", frontImage);
    }
    UploadKYCDoc(uploadPayload)
      .then((res) => {
        setOtpModalVisible(false);
        setLoading(false);
        console.log("res", res);
        if (
          res.statusCode != 500 &&
          res.message != "Failed" &&
          res.statusCode == 200
        ) {
          setAlertModal({
            title: "Successful",
            status: "success",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });

          setAlertModalVisible(true);
          resetData();
        } else {
          resetData();
          setLoading(false);
          setOtpModalVisible(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            statusCode: res.statusCode,
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        resetData();
        setLoading(false);
        console.log("err", err);
        setOtpModalVisible(false);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          statusCode: err?.statusCode,
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });
  };

  const onClickGetOtp = async () => {
    setLoading(true);
    let token = await AsyncStorageFunc.getData("TOKEN");
    let reqObj = {
      type: "kycUpdate",
      id: token ? jwtDecode(token).userCd : "",
    };

    sendOtpApi(reqObj)
      .then((res) => {
        setLoading(false);
        if (res.statusCode == 200 || res.statusCode == 1003) {
          setOtpData(res)
          setOtpModalVisible(true);
        } else if (
          res.statusCode == -1001 ||
          res.statusCode == 500 ||
          res.statusCode == -1003
          || res.statusCode == -1007
        ) {
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true);
      });
  };

  
    const _updateKyc = (req) => {
      let  encKey = ""
      setLoading(true)
      let reqObj = {
        deviceId: "KA03MP1234",
      };
      getEncryptKey(reqObj)
            .then((encRes) => {
              encKey =  encRes.data
              encrypt(
                 `${req.panNumber}`,
                encRes.data
              ).then(async(encPan) => {
                let encFullName = await encrypt(req?.fullName,encKey);
                let encDob = await encrypt(req?.dob,encKey);
                let params = {
                  fullName : encFullName,
                  dob : encDob,
                  panNumber:encPan,
                  action: kycStatus == "Min KYC" ? "NKYC2EKYC" : kycStatus == "Manual KYC" ? "KYC2EKYC" : "UPDATE"                 }
            
                 updateKyc(params).then((res) => {
                  setLoading(false)
                  if(res?.statusCode == 200){
                    setAlertModalVisible(true);
                    setAlertModal({
                      title: "Request Initiated",
                      status: "request_initiated",
                      message: res.message,
                      navigateScreen: "service request",
                      actionButton: "OK",
                    });
                  }else {
                    setLoading(false)
                    setAlertModalVisible(true);
                    setAlertModal({
                      title: "Error",
                      status: "error",
                      message: res.message,
                      navigateScreen: "",
                      actionButton: "OK",
                    });
                  }
                  
                 }).catch((err) => {
                  setLoading(false)
                  setAlertModalVisible(true);
                  setAlertModal({
                    title: "Error",
                    status: "error",
                    message: res.message,
                    navigateScreen: "",
                    actionButton: "OK",
                  });
                 })   
              })
            })   
  }

  return (
    <>
      <View style={styles.KYCUpd}>
        <View>
          <CText.basicInformation style={{ color: COLORS.brownishGrey }}>KYC Upgrade</CText.basicInformation>
        </View>

        <View style={styles.KYCUpd_row2}>
          <View style={styles.KYCUpd_row2_KYCInfo}>
            <View style={styles.KYCUpd_row2_KYCInfo_fullKYC}>
              <CText.kycTypeText>Full KYC Benefits</CText.kycTypeText>
              <View style={{ marginTop: 10 }}>
                <CText.kycDesc>{"Avail balances upto ₹ 1,00,000.\nUnlimited debit or credit per month and year"}</CText.kycDesc>
              </View>
              <Image source={crownicon} style={styles.crownIcon} />
            </View>
            <View style={styles.KYCUpd_row2_KYCInfo_minKYC}>
              <CText.kycTypeText>Min KYC Benefits</CText.kycTypeText>
              <View style={{ marginTop: 10 }}>
                <CText.kycDesc>{"You can transact up to ₹ 10,000 per month.\nNo action needed."}</CText.kycDesc>
              </View>
            </View>
          </View>
          <View style= {styles.contentTwoStyle}>
          <CServiceReqBoxView 

              setTncModalVisible={setTncModalVisible}
              value={panNumber.toUpperCase()}
               onChangeText= {(e) => setPanNumber(e)}
               onValidation={(isValid) => setIsPanValidated(isValid)}
              placeHolder={"Enter PAN Number"}
              onSubmitPress={_updateKyc}
              disable={!isPanValidated}
              type={"pan"}
              screen = "KYC_UPDATE"
            />
          </View>
        </View>
      </View> 
      {otpModalVisible && <OtpModal data={otpData} onSuccess={onUpload} getOtp={onClickGetOtp} type  = "kycUpdate" />}

      {alertModalVisible ? (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />
        </View>
      ) : null}
      {tncModalVisible && <CDocxViewer type = "FF_KYC" visibility={setTncModalVisible}/>}
        



      {loading && <Loader />}
    </>
  );
}

